import { render } from "./ScrollDown.vue?vue&type=template&id=c21a23a6"
import script from "./ScrollDown.vue?vue&type=script&lang=js"
export * from "./ScrollDown.vue?vue&type=script&lang=js"

import "./ScrollDown.vue?vue&type=style&index=0&id=c21a23a6&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__